import { createTheme } from '@mui/material/styles';

// Mirrors the CSS custom properties in index.css so MUI components (Dialog,
// TextField, Button, …) match the rest of the site instead of MUI defaults.
export const theme = createTheme({
  palette: {
    primary: { main: '#c8102e' },
    text: { primary: '#090909', secondary: '#757575' },
    background: { default: '#fafafa', paper: '#fcfcfc' },
  },
  typography: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 999,
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          borderRadius: 16,
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          fontWeight: 800,
          fontSize: 22,
        },
      },
    },
  },
});
